import { DonationFormCategory, FormCategory, PrimaryMainColor, TicketingFormCategory } from "@simplyk/common";

export const DEFAULT_FORM_COLOR_BY_CATEGORY: Record<FormCategory, string> = {
  [TicketingFormCategory.Event]: "#F77A61",
  [TicketingFormCategory.Auction]: "#A3BFFE",
  [TicketingFormCategory.MembershipV2]: "#F85D89",
  [TicketingFormCategory.Lottery]: "#6290FD",
  [TicketingFormCategory.Sweepstakes]: "#6290FD",
  [TicketingFormCategory.Shop]: "#B8DE51",
  [TicketingFormCategory.Custom]: PrimaryMainColor,
  [DonationFormCategory.DonationForm]: "#6CD4C2",
  [DonationFormCategory.PeerToPeerCampaign]: "#FFC852",
};

export const getDefaultFormColor = (category: FormCategory): string =>
  DEFAULT_FORM_COLOR_BY_CATEGORY[category] ?? PrimaryMainColor;
